import { computed, makeAutoObservable } from "mobx";
import { TaskWithContent } from "../../DTO/ServerResponseType/Task/Task";
import TaskServerClient from "../../ServerClients/TaskServerClient";
import { ModuleResourceTypeEnum } from "../../Enums/ModuleResourceTypeEnum";

export class TasksStore {
  public tasks: TaskWithContent[] = [];
  public filterType: number = -1;

  constructor() {
    makeAutoObservable(this);
  }

  onChangeFilterType = (
    eventOrType: React.FormEvent<HTMLSelectElement> | number
  ): void => {
    if (typeof eventOrType === "number") this.filterType = eventOrType;
    else
      this.filterType = parseInt(
        eventOrType.currentTarget.options[
          eventOrType.currentTarget.selectedIndex
        ].value
      );
  };

  @computed
  get filteringTasks(): TaskWithContent[] {
    if (this.filterType === -1) return this.tasks;
    else if (
      this.filterType === ModuleResourceTypeEnum.MiniGame ||
      this.filterType === ModuleResourceTypeEnum.Task
    )
      return this.tasks.filter(
        (task) =>
          task.taskContent.isMiniGame ===
          (this.filterType === ModuleResourceTypeEnum.MiniGame)
      );
    else return [];
  }

  selectedTask(
    event: React.FormEvent<HTMLSelectElement>
  ): TaskWithContent | undefined {
    let eventOption =
      event.currentTarget.options[event.currentTarget.selectedIndex];

    if (eventOption)
      return this.tasks.find((task) => task.taskId === eventOption.value);
  }

  setTasks = (tasks: TaskWithContent[]) => {
    this.tasks = tasks;
  };

  public loadAllTasksAsync = async (): Promise<TaskWithContent[] | never> => {
    return TaskServerClient.sendToGetAllTasksAsync().then((tasks) => {
      this.setTasks(tasks);
      return tasks;
    });
  };
}
